import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { FiltroInformeNhCenso } from '../../../domain/model/no-hospitalario/informes/entity/filtro-informe-nh-censo.model';
import { TipoInformeNh } from '../../../domain/model/no-hospitalario/informes/entity/tipo-informe.model';
import { InformesNhGateway } from '../../../domain/model/no-hospitalario/informes/gateway/informes-nh-gateway';

@Injectable({
  providedIn: 'root'
})
export class InformesNhService extends InformesNhGateway {

  private readonly url: string;
  private readonly port: string;

  constructor(private http: HttpClient) {
    super();
    this.url = `${environment.apiBaseUrl}`;
    this.port = `${environment.portBaseUrl}`;

  }

  public consultarInformeNhCenso(filtros: FiltroInformeNhCenso): Observable<any> {
    const URL = `${this.url}${this.port}/api_informes/informes/informeCensoNoHospitalario`;

    let parametros = '';

    if (filtros.idCiudad != null && filtros.idCiudad !== '') {
      const ciudad = `ciudad=${filtros.idCiudad}&`;
      parametros = parametros.concat(ciudad);
    }
    if (filtros.idTipoAtencion !== '') {
      const tipoServicio = `tipoServicio=${filtros.idTipoAtencion}&`;
      parametros = parametros.concat(tipoServicio);
    }
    if (filtros.fechaInicio != null && filtros.fechaInicio !== '') {
      const desde = `desde=${filtros.fechaInicio}&`;
      parametros = parametros.concat(desde);
    }
    if (filtros.fechaFin != null && filtros.fechaFin !== '') {
      const hasta = `hasta=${filtros.fechaFin}`;
      parametros = parametros.concat(hasta);
    }

    return this.http.get(URL.concat(`?${parametros}`), { responseType: 'text', withCredentials: true });
  }

  public consultarInformeNhRespaldoProgramacion(filtros: FiltroInformeNhCenso): Observable<any> {
    const URL = `${this.url}${this.port}/api_informes/informes/informeRespaldoProgramacionNH`;

    let parametros = '';

    if (filtros.idCiudad != null && filtros.idCiudad !== '') {
      const ciudad = `ciudad=${filtros.idCiudad}&`;
      parametros = parametros.concat(ciudad);
    }
    if (filtros.idTipoAtencion !== '') {
      const tipoServicio = `tipoServicio=${filtros.idTipoAtencion}&`;
      parametros = parametros.concat(tipoServicio);
    }
    if (filtros.fechaInicio != null && filtros.fechaInicio !== '') {
      const desde = `desde=${filtros.fechaInicio}&`;
      parametros = parametros.concat(desde);
    }
    if (filtros.fechaFin != null && filtros.fechaFin !== '') {
      const hasta = `hasta=${filtros.fechaFin}`;
      parametros = parametros.concat(hasta);
    }

    return this.http.get(URL.concat(`?${parametros}`), { responseType: 'text', withCredentials: true });
  }

  public consultarInformesNh(codigoTipo: number): Observable<TipoInformeNh[]> {
    const url = `${this.url}${this.port}/api_ingreso/tipo-informe`;
    return this.http.get<TipoInformeNh[]>(`${url}/${codigoTipo}`);
  }




}
